import styled from '@emotion/styled'
import ShadowBox from '@unowmooc/shadow-box'
import { colors } from 'styles-resources'

export default styled(ShadowBox)`
  padding: 30px;
  background-color: ${colors.white};
`
